// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

const proposals = require.context('.', true, /\.js$/)
proposals.keys().forEach(proposals)
